import React, { useState, useEffect } from "react";
import { IonItem, IonLabel } from "@ionic/react";

const Pictographs: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [questions, setQuestions] = useState<any[]>([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);
    const [selectedOption, setSelectedOption] = useState<number | null>(null);

    const objects = [
        "🍎 Apples", "🍌 Bananas", "🍇 Grapes", "🍊 Oranges",
        "🚌 Buses", "🚲 Bicycles", "🐕 Dogs", "🐈 Cats",
        "🐦 Birds", "🐟 Fish", "🍓 Strawberries", "🥕 Carrots",
        "🍍 Pineapples", "🌽 Corn", "🍉 Watermelons", "🍋 Lemons",
    ];

    const generatePictographData = () => {
        const selectedObjects = [];
        const usedIndices = new Set<number>();
        const usedQuantities = new Set<number>();

        while (selectedObjects.length < 4) {
            const randomIndex = Math.floor(Math.random() * objects.length);
            const quantity = Math.floor(Math.random() * 9) + 1;

            if (!usedIndices.has(randomIndex) && !usedQuantities.has(quantity)) {
                selectedObjects.push({ object: objects[randomIndex], quantity });
                usedIndices.add(randomIndex);
                usedQuantities.add(quantity);
            }
        }
        return selectedObjects;
    };

    const generateQuestions = (pictographData: any[]) => {
        const total = pictographData.reduce((acc, item) => acc + item.quantity, 0);
        return [
            {
                question: `How many ${pictographData[0].object.split(" ")[1]} are represented?`,
                answer: pictographData[0].quantity,
            },
            {
                question: `How many ${pictographData[1].object.split(" ")[1]} are represented?`,
                answer: pictographData[1].quantity,
            },
            {
                question: `Which object has the highest quantity?`,
                answer: pictographData.reduce((max, item) => item.quantity > max.quantity ? item : max).object,
            },
            {
                question: `What is the total number of objects represented?`,
                answer: total,
            },
        ];
    };

    const handleQuestion = () => {
        const newData = generatePictographData();
        setData(newData);
        setQuestions(generateQuestions(newData));
        setCurrentQuestionIndex(Math.floor(Math.random() * 4));
        setError(false);
        setSelectedOption(null);
    };

    useEffect(() => {
        handleQuestion();
        document.title = "Mamas Guidance - Class One - Mathematics - Data Handling - Pictographs"; // Set page title
    }, []);

    const handleAnswerSubmit = (userAnswer: any) => {
        setSelectedOption(userAnswer);
        const correctAnswer = questions[currentQuestionIndex].answer;

        if (userAnswer === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                setShowImage(false);
                handleQuestion();
            }, 3000);
        } else {
            setError(true);
        }
    };

    return (
        <>
            {!showImage ? (
                <div className="contentPart showCenter additionWord" style={{ padding: "0%" }}>
                    <div>
                        <div className="mb-4">
                            {data.map((item, index) => (
                                <IonItem key={index}>
                                    <IonLabel>
                                        <strong>{item.object.split(" ")[1]}:</strong>
                                        <span style={{ fontSize: "20px" }}>
                                            {Array(item.quantity).fill(item.object.split(" ")[0]).join(" ")}
                                        </span>
                                    </IonLabel>
                                </IonItem>
                            ))}
                        </div>
                        <div>
                            <h3>Question:</h3>
                            {questions.length > 0 && <p>{questions[currentQuestionIndex].question}</p>}
                        </div>
                        <div className="" style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                            {typeof questions[currentQuestionIndex]?.answer === "number" ? (
                                [questions[currentQuestionIndex].answer - 1, questions[currentQuestionIndex].answer, questions[currentQuestionIndex].answer + 1]
                                    .sort(() => Math.random() - 0.5)
                                    .map((option, index) => (
                                        <div className={`background-blue ${selectedOption === option
                                            ? option === questions[currentQuestionIndex].answer
                                                ? 'correct'
                                                : 'incorrect'
                                            : ''}`}
                                            key={index}
                                            onClick={() => handleAnswerSubmit(option)}
                                            style={{ width: 'auto', padding: '10px', fontSize: '30px', background: "none", color: 'inherit' }}
                                        >
                                            {option}
                                        </div>
                                    ))
                            ) : (
                                data.map((item, index) => (
                                    <div className={`background-blue ${selectedOption === item.object
                                        ? item.object === questions[currentQuestionIndex].answer
                                            ? 'correct'
                                            : 'incorrect'
                                        : ''}`}
                                        key={index}
                                        onClick={() => handleAnswerSubmit(item.object)}
                                        style={{ width: 'auto', padding: '10px', fontSize: '30px', background: "none", color: 'inherit' }}
                                    >
                                        {item.object.split(" ")[0]}
                                    </div>
                                ))
                            )}
                        </div>
                        <div className="text-center">
                            {error && <p className="error-text">❌ Oops! Try again.</p>}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: '150px' }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK}
                        alt="Well Done"
                    />
                </div>
            )}
        </>
    );
};

export default Pictographs;
